export const DECIMAL_PRECISION = 2;

export function roundToDecimal(
  value: number,
  precision: number = DECIMAL_PRECISION,
): number {
  if (!Number.isFinite(value)) return value;
  return Number(value.toFixed(precision));
}

export function formatDecimal(
  value: number,
  precision: number = DECIMAL_PRECISION,
): string {
  return String(roundToDecimal(value, precision));
}

/**
 * Treat a comma as a decimal separator when the value looks like `5,5`.
 * Values that already use a period (including `1,234.56`) are left unchanged.
 */
export function normalizeDecimalInput(value: unknown): unknown {
  if (typeof value !== "string") return value;

  const trimmed = value.trim().replace(/\s/g, "");
  if (!trimmed) return value;

  if (/^-?\d+,\d+$/.test(trimmed) && !trimmed.includes(".")) {
    return trimmed.replace(",", ".");
  }

  return trimmed;
}

export function parseDecimal(value: unknown): number | null {
  const normalized = normalizeDecimalInput(value);
  if (normalized == null || normalized === "") return null;
  const numeric =
    typeof normalized === "number" ? normalized : Number(normalized);
  if (!Number.isFinite(numeric)) return null;
  return roundToDecimal(numeric);
}
